export const MANUFACTURER_GROUP = 'Manufacturer';
export const GRIPPER_GROUP = 'Gripper';
export const ADMIN_GROUP = 'Admin';
